<template>
  <div>
    <div v-if="department">
      <div v-if="departMoney">
        <div>部门通用奖金机制（填写内容适用部门所有人员）:</div>
        <el-input
          type="textarea"
          size="mini"
          placeholder="部门通用奖金机制，填写内容适用部门所有人员"
          v-model="departJi"
          title="部门通用奖金机制，填写内容适用部门所有人员"
        >
        </el-input>
      </div>
      <div v-else>部门奖金机制:请先填写正确的公司</div>
    </div>
    <div v-else>部门奖金机制:请先填写部门</div>
    <div v-if="cate">
      <div v-if="cateMoney">
        <div>职能模块通用奖金机制（与职能模块联动）:</div>
        <div style="display:flex">
          <div style="width:30%">
            <el-select
              v-model="cate"
              size="mini"
              filterable
              placeholder="选择职能模块"
              @change="setCateJi"
              title="选择职能模块"
              style="width:100%"
            >
              <el-option v-for="(c, k) in cates" :key="k" :label="c" :value="c"></el-option>
            </el-select>
          </div>
          <el-input
            type="textarea"
            size="mini"
            placeholder="职能模块通用奖金机制，与左侧职能模块联动"
            v-model="cateJi"
            title="职能模块通用奖金机制，与左侧职能模块联动"
            style="width:70%"
          >
          </el-input>
        </div>
      </div>
      <div v-else>职能模块奖金机制:请先填写正确的公司</div>
    </div>
    <div v-else>职能模块奖金机制:请先填写职能模块</div>
  </div>
</template>
<script>
export default {
  props: {
    company: {
      type: String,
      default: '',
    },
    department: {
      type: String,
      default: '',
    },
    cates: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      cateMoney: null,
      cateJi: '',
      cate: '',
      departMoney: null,
      departJi: '',
    }
  },
  watch: {
    company: async function() {
      await this.loadDepartMoney()
      await this.loadCateMoney()
      this.setCateJi()
    },
    department: async function() {
      await this.loadDepartMoney()
    },
    cates: function(nv) {
      this.cate = nv[0] || ''
      this.setCateJi()
    },
    cateJi: function(nv) {
      if (this.cate && nv) {
        this.cateMoney = this.cateMoney || {}
        this.cateMoney[this.cate] = this.cateMoney[this.cate] || { content: {}, table: [] }
        this.cateMoney[this.cate].content = this.cateMoney[this.cate].content || { 奖金机制: '' }
        this.cateMoney[this.cate].content['奖金机制'] = nv
      }
    },
    departJi: function(nv) {
      if (this.department && nv) {
        this.departMoney = this.departMoney || { content: {}, table: [] }
        this.departMoney.content = this.departMoney.content || { 奖金机制: '' }
        this.departMoney.content['奖金机制'] = nv
      }
    },
  },
  methods: {
    async loadCateMoney() {
      if (this.company && this.cates.length > 0) {
        this.cateMoney = null
        const com = await app.service('company').getCategoryMoney({ 公司: this.company })
        // console.log('cate', com)
        if (com.status === 200) {
          if (com.msg != '公司不存在') {
            this.cateMoney = com.data || {}
          }
        }
      }
    },
    async loadDepartMoney() {
      if (this.company && this.department) {
        this.departMoney = null
        const com = await app.service('company').getDepartmentMoney({ 公司: this.company, 部门: this.department })
        // console.log(com)
        if (com.status === 'success') {
          this.departMoney = com.data || {}
          this.departJi = this.departMoney && this.departMoney.content ? this.departMoney.content['奖金机制'] : ''
        }
      }
    },
    setCateJi() {
      if (this.cate && this.cateMoney) {
        this.cateJi =
          this.cateMoney[this.cate] && this.cateMoney[this.cate].content
            ? this.cateMoney[this.cate].content['奖金机制']
            : ''
      } else {
        this.cateJi = ''
      }
    },
    async saveMoney() {
      if (this.company) {
        if (this.cate && this.cateMoney) {
          await app.service('company').updateCategoryMoney({ 公司: this.company, data: this.cateMoney })
        }
        if (this.department && this.departMoney) {
          await app
            .service('company')
            .updateDepartmentMoney({ 公司: this.company, 部门: this.department, data: this.departMoney })
        }
      }
    },
  },
  async mounted() {
    this.cate = this.cates[0] || ''
    await this.loadDepartMoney()
    await this.loadCateMoney()
    this.setCateJi()
  },
}
</script>
